import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const LAYOUT_PAGE_TITLE = new InjectionToken<BehaviorSubject<string>>('');
